export default __webpack_public_path__ + "static/media/scan-bunifikasi-logotype-l.cba0c0f4.svg";